<template>
  <div class="dashboard">
    <Title></Title>
    <Three></Three>
    <div class="extras">
      <Extras images="besucherzahlen">Auslastung</Extras>
      <Extras images="auslastung">Besucherzahlen</Extras>
      <Extras images="beliebtheit">Beliebtheit der Ausstellung</Extras>
<!--      <div class="shadow">-->
<!--        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nulla, tempora.-->
<!--      </div>-->
<!--      <div class="shadow">-->
<!--        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nulla, tempora.-->
<!--      </div>-->
<!--      <div class="shadow">-->
<!--        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nulla, tempora.-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Three from '@/views/Three.vue';
import Title from '@/components/Title.vue';
import Extras from '@/components/Extras.vue';

export default {
  name: 'Dashboard',
  components: {
    Extras,
    Title,
    Three,
  },
};
</script>

<style scoped lang='scss'>
  .dashboard {
    display: flex;
    flex-wrap: wrap;
  }

  .extras {
    width: 100%;
    display: grid;
    /*flex-wrap: wrap;*/
    margin-top: 1rem;
    margin-bottom: 1rem;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    /*height: auto;*/

    @media (max-width: 1500px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 767.98px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>
